module.exports = __webpack_public_path__ + "static/media/benessere.29fe20ba.jpg";